import { CELLS, getDefaultColumnParams } from "@/helpers/table.helpers"
import { TranslationKeyCell } from "@/pages/ReportsPage/components/molecules/TranslationKeyCell"
import { InitiatorCell } from "./components/InitiatorCell"
import { ResourceCell } from "./components/ResourceCell"
import { ScanDate } from "./components/ScanDate"
import { ScanID } from "./components/ScanIdCell"
import { ScanResultCell } from "./components/ScanResultCell"

import type { SortOrder } from "@/atoms"
import type { useNumberConvertor } from "@/hooks/useNumberConvertor"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTable = (props: {
  t: TFunction
  convertors: ReturnType<typeof useNumberConvertor>
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
  popover?: boolean
  canReview: boolean
}) => [
  {
    title: "Scan ID",
    render: ScanID(props),
    width: 145,
    ...getDefaultColumnParams("shortScanId")
  },
  {
    title: "Scan Type",
    render: TranslationKeyCell(props.t),
    width: 160,
    ...getDefaultColumnParams("scanTypeKey", props.sorter, {
      customSorterName: "scanType"
    })
  },
  {
    title: "Policy Result",
    render: ScanResultCell(props.t),
    className: "no-opacity-ks",
    // Fits the longest result tag and exception state on one line: ~234px of text, plus the cell's padding.
    width: 250,
    ...getDefaultColumnParams("policyStatus", props.sorter, {
      customSorterName: "policyResult"
    })
  },
  {
    title: "Resource Scanned",
    render: ResourceCell(props),
    ...getDefaultColumnParams("resourceScanned", props.sorter)
  },
  CELLS.getIssuesSummaryCell(props, {
    customSorterName: "issuesSummary",
    defaultSortOrder: undefined
  }),
  {
    title: "Initiator",
    width: 79,
    render: InitiatorCell(props.t),
    className: "center-align-tab-template-component",
    ...getDefaultColumnParams("initiator", props.sorter)
  },
  {
    title: "Scan Date",
    render: ScanDate(props.t),
    width: 150,
    ...getDefaultColumnParams("scanDate", props.sorter, {
      customSorterName: "startTime"
    }),
    defaultSortOrder: "descend" as SortOrder
  }
]
